import api from "../config/api"


export const getALLFixedDestinations = async () => {
    const response = await api.get('/fixedDestination/');
    return response.data;
}

export const getFixedDestinationById = async (id) => {
    const response = await api.get(`/fixedDestination/?id${id}`);
    return response.data;
}

export const saveFixedDestination = async (data) => {
    const response = await api.post(`/fixedDestination/`, data, {
        headers: { "Content-Type": "application/json" },
    })
    return response;
}

export const deleteFixedDestination = async (id) => {
    const response = await api.delete(`/fixedDestination/?id=${id}`);
    return response.data;
}